import React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { FeedbackContext } from '@cvt/contexts';

import { cacheKeys } from '../config';
import { universityClient } from '../client/universityClient';


export const useUniversityCrud = () => {
  const { genericErrorFeedback } = React.useContext(FeedbackContext);

  const queryClient = useQueryClient();


  const likeUniversity = useMutation({
    mutationKey: [cacheKeys.likeUniversity],
    mutationFn: (id: number) => universityClient.likeUniversity({ id }),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getUniversities],
      });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getUniversity, id],
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  const unlikeUniversity = useMutation({
    mutationKey: [cacheKeys.unlikeUniversity],
    mutationFn: (id: number) => universityClient.unlikeUniversity({ id }),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getUniversities],
      });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getUniversity, id],
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  const ignoreUniversity = useMutation({
    mutationKey: [cacheKeys.ignoreUniversity],
    mutationFn: (id: number) => universityClient.ignoreUniversity({ id }),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getUniversities],
      });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getUniversity, id],
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  const applyToUniversity = useMutation({
    mutationKey: [cacheKeys.applyToUniversity],
    mutationFn: (data: {
      university: number;
      specialization?: number;
    }) => universityClient.applyToUniversity(data),
  });

  return {
    likeUniversity: likeUniversity,
    unlikeUniversity: unlikeUniversity,
    ignoreUniversity: ignoreUniversity,
    applyToUniversity: applyToUniversity,
  };
};
